/* UNSCRIPTED 60-second recall test, part 4: result types, email gate and lead capture.
   The email gate sits between the loader and the result, like the other quiz funnels. Leads post to the coach server (/api/lead),
   which stores only its whitelisted fields, so the score travels in: level = "13/18", answers = [q1, q2, q3, positions, digits, q4].
   The email is the address the free Day 0 sheet and the AI Recall Coach access are sent to (those emails go out at checkout): it is kept in
   sessionStorage (um_quiz_email) and snippets/unscripted-free-offer fills it into the checkout. */
const TYPES = {
  outsourcer: {
    name: "The Full Outsourcer",
    line: "Your phone holds most of it, and the memory tests were a stretch.",
    diag: "Your phone and notes carry most of what you need to remember, and both memory tests were hard. That is a clear starting point. You do not need a good memory to begin, because the method supplies the structure.",
    start: { where: "Day 0 baseline, pp. 20 to 23, then your first ten stations, pp. 52 to 63", why: "Measure first, then build your first ten stations." }
  },
  navigator: {
    name: "The Hidden Navigator",
    line: "You hold things well in the tests, and your habits hand the facts to your phone.",
    diag: "You did well on the memory tests, which is the skill this method builds on. Your habits still send most facts to your phone first, so that strength is not being used on what you care about.",
    start: { where: "Micro-Palace, pp. 52 to 63", why: "Put the facts you currently save onto places you already know, one fact per station." }
  },
  willing: {
    name: "The Willing Rememberer",
    line: "You try to recall first, and the effort has no method behind it yet.",
    diag: "You try to recall before you check, which is the habit the method asks for. The memory tests were harder, which suggests the effort has nowhere to put things yet. A method gives it a structure.",
    start: { where: "The Encoding Event, p. 19", why: "Turn one fact into one vivid picture, then place it on a station." }
  },
  keeper: {
    name: "The Natural Keeper",
    line: "You recall first and you did well on both tests. Your starting point is high.",
    diag: "Your habits and both memory tests are strong. The manual is less about starting and more about holding more, for longer, and under pressure.",
    start: { where: "Three-Second Glance, p. 62, then the Day 30 retest, p. 138", why: "Practise retrieving without a pause, then retest and compare against today." }
  }
};

function gate() {
  track("quiz_gate_view");
  mount(`
    <section class="gate">
      <p class="eyebrow">&#9679; Score ready</p>
      <h2 class="gh">Your recall score is ready.</h2>
      <div class="lockscore" aria-hidden="true"><b>&bull;&bull;</b><span>/ 18</span></div>
      <p>Enter your email to see your score. We use it to send your free Day 0 sheet and your AI Recall Coach access as soon as you claim your manual.</p>
      <form class="field" id="gateform" novalidate>
        <label for="email">Your best email</label>
        <input id="email" name="email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="you@example.com" required>
        <p class="err" id="err" role="alert"></p>
        <button class="cta" type="submit">Show my score</button>
      </form>
      <p class="privacy">Your results load on the next screen, right away. No spam, unsubscribe in one click, and we never sell your email.</p>
    </section>`, ".gh");
  const form = document.getElementById("gateform"), input = document.getElementById("email"), err = document.getElementById("err");
  input.addEventListener("input", () => { err.textContent = ""; });
  form.addEventListener("submit", e => {
    e.preventDefault();
    const email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = "That email doesn’t look quite right. Mind checking it?"; input.focus(); return; }
    st.email = email; st.unlocked = true;
    try { sessionStorage.setItem("um_quiz_email", email); } catch (e) {}
    submitLead();
    go("result");
  });
}

function submitLead() {
  const h = habit(), s = st.sScore, d = st.dScore, total = h + s + d, key = typeKey(h, s + d);
  const q4 = st.ans.q4 != null ? Q.q4.opts[st.ans.q4][0] : null;
  const payload = {
    email: st.email, funnel: FUNNEL.slug, type: key, type_name: TYPES[key].name, secondary_type: null,
    level: total + "/18", topic: q4,
    answers: [st.ans.q1, st.ans.q2, st.ans.q3, s, d, st.ans.q4].map(v => (Number.isInteger(v) ? v : null)),
    attribution: ATTR, page: location.href.split("?")[0], submitted_at: new Date().toISOString()
  };
  try { if (META_ON && window.fbq) fbq("init", CONFIG.metaPixelId, { em: st.email.toLowerCase() }); } catch (e) {}
  track("generate_lead", { quiz_type: key, quiz_score: total });
  if (!CONFIG.webhookUrl) return;
  try {
    // text/plain keeps this a simple request (no CORS preflight); the coach server parses it as JSON
    fetch(CONFIG.webhookUrl, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: JSON.stringify(payload), keepalive: true }).catch(() => {});
  } catch (e) {}
}